// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapboxgl-ctrl-geocoder--icon-search {\n  display: none;\n}\n.mapboxgl-ctrl-geocoder--pin-right {\n  display: none;\n}\n.suggestions-wrapper {\n  margin-top: 0.5rem;\n  position: absolute;\n  background-color: white;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  border-radius: 0.375rem;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
